<template>
  <img
    alt="Logo Racing Analytics"
    src="@/assets/images/logo.svg"
    width="16"
  />
</template>

<script>
export default {
  name: 'AppLogo',
};
</script>
